// extracted by mini-css-extract-plugin
export var editButton = "_nk-0";